// import TextToSpeech from '../../TextToSpeech/textToSpeech';
// import Counter from '../../components/Counter/Counter';
import ArttuImage from '../../assets/arttu.png';
import { FaLinkedin, FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";

const teamMembers = [
  {
    name: "Arttu Stenius",
    role: "Yrittäjä | Perustajajäsen",
    image: ArttuImage,
    description: (
<>
  Moi! Olen Arttu, Spiderlegs Productionsin perustajajäsen. Rumpalina olen esiintynyt eri bändeissä 90-luvun alusta lähtien ja vuosien varrella kertynyt kokemus on opettanut minulle paljon tapahtumien järjestämisestä ja tekniikasta niin lavalla kuin sen takana.<br /><br />

  Rakensin tämän sivuston todellisesta tarpeesta: helpottaakseni tapahtumien suunnittelua ja toteutusta. Halusin yhdistää kaiken olennaisen: äänentoiston ja esitystekniikan vuokrauksen, esiintyjille näkyvyyttä ja keikkoja, sekä ennen kaikkea tuoda ihmiset viihtymään livemusiikin pariin. Esiintyjäbuukkaukset onnistuvat ilman tarjousrumbaa tai sähköpostiketjuja, vain muutamalla klikkauksella. Mikä muka olisi parempaa kuin livemusiikki tapahtumassa?<br /><br />

  Tarjoamme myös peräkärryn vuokrausta, kaikki toimii saman helppokäyttöisen järjestelmän kautta.<br /><br />

  Palvelumme on asiakaslähtöinen ja joustava. Oli kyseessä sitten intiimit kotibileet, häät tai yritystapahtuma, löydät meiltä sopivat ratkaisut helposti. Ja jos tarvitset apua, saat aina nopeaa ja henkilökohtaista asiakaspalvelua suoraan minulta.<br /><br />
</>

    )
    
  },
];

const Team = () => {
  return (
    <div className="team-section py-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 ">

        {/* Ensimmäinen laatikko (Sinua palvelee) */}
        <div className="team-member flex flex-col p-6 shadow-lg bg-white bg-opacity-80 dark:bg-violet dark:bg-opacity-80">
          <div>
            <h2 className="font-customFont2 dark:text-shadow-xxl text-center text-darkest dark:text-primary text-5xl font-bold leading-tight">
              Sinua palvelee
            </h2>
            <img
              src={teamMembers[0].image}
              alt={`${teamMembers[0].name} kuva`}
              className="rounded-full w-60 h-60 mx-auto mb-6 object-cover"
            />
            <h3 className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-3xl font-bold leading-tight">
              {teamMembers[0].name}
            </h3>
            <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg font-light">
              {teamMembers[0].role}
            </p>
            <p className="mt-4 font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg font-light">
              {teamMembers[0].description}
            </p>
          </div>
        </div>

        {/* Toinen laatikko (Yhteystiedot) */}
{/* Toinen laatikko (Yhteystiedot) */}
<div className="contact-info font-customFont1 flex flex-col p-6 bg-white bg-opacity-80 dark:bg-violet dark:bg-opacity-80">
  <div>
    <h3 className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-4xl text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-4xl font-bold leading-tight mb-4">
      <strong>Yhteystiedot</strong>
    </h3>
    <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold">
      <strong>Sähköposti: </strong>
      <a href="mailto:arttu@spiderlegsproductions.com" className="text-darkest dark:text-primary underline" aria-label="Lähetä sähköposti Arttulle">
        arttu@spiderlegsproductions.com
      </a>
    </p>
    <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold mt-2">
      <strong>Puhelin: </strong>
      <a href="tel:+358443519265" className="text-darkest dark:text-primary" aria-label="Soita Arttulle">
        +358 44 351 92 65
      </a>
    </p>
    <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold mt-2">
      <strong>Aukioloajat: </strong>
      <span className="text-darkest dark:text-primary">
        Ma–Pe: 8:00–18:00, La: 10:00–17:00. Myös joustavasti sopimuksen mukaan.
      </span>
    </p>
    <p className="mt-6 font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold underline">
      <strong>
        Ota rohkeasti yhteyttä – vastaamme nopeasti ja autamme kaikissa tapahtumasi järjestämiseen liittyvissä asioissa.
      </strong>
    </p>
  </div>

  <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mt-6">
  Olemme toimittaneet äänentoistoa yli 30 tapahtumaan ja palvelleet satoja asiakkaita ympäri Etelä-Suomen.
</p>


  {/* <div className="flex flex-col items-center mt-10">
    <Counter end={36} label="Toteutettua vuokrausprojektia" />
    <Counter end={324} label="Tyytyväistä asiakasta" />
    <Counter end={12} label="Tapahtumaa vuodessa" />
  </div> */}
<div className="mt-10 text-center">
  <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">Liketä somessa!</p>
  <div className="flex justify-center space-x-6 my-5">
    <a
      href="https://www.facebook.com/spiderlegsproductions/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Spiderlegs Productions Facebook"
      title="Seuraa Facebookissa"
      className="hover:scale-110 transition-transform duration-200"
    >
      <FaFacebook size={30} />
    </a>
    <a
      href="https://www.instagram.com/spiderlegsproductions/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Spiderlegs Productions Instagram"
      title="Seuraa Instagramissa"
      className="hover:scale-110 transition-transform duration-200"
    >
      <FaInstagram size={30} />
    </a>
    <a
      href="https://www.linkedin.com/in/spiderlegs-productions/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Spiderlegs Productions LinkedIn"
      title="Seuraa LinkedInissä"
      className="hover:scale-110 transition-transform duration-200"
    >
      <FaLinkedin size={30} />
    </a>
    <a
      href="https://www.tiktok.com/@spiderlegsproductions"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Spiderlegs Productions TikTok"
      title="Seuraa TikTokissa"
      className="hover:scale-110 transition-transform duration-200"
    >
      <FaTiktok size={30} />
    </a>
  </div>
</div>

</div>


      </div>
    </div>
  );
};      

export default Team;
